'use strict';

export const importDataConstants = {
  importError: {
    defaultHeader: 'Import Errors'
  }
};
